import type { MultiPolygon, Polygon, Position } from "geojson";
import bbox from "@turf/bbox";

/** Bbox-midpoint of a Polygon / MultiPolygon — a good-enough centroid for ag-field shapes.
 *  Deliberately the bounding-box center, not the area-weighted centroid (`polygonCentroid`):
 *  it's cheaper and, for the convex-ish field boundaries we deal with, lands inside the shape
 *  and reads as "the middle" without the pull a true centroid gets from concave edges. */
export function polygonBboxCenter(geom: Polygon | MultiPolygon): Position {
	const [minLng, minLat, maxLng, maxLat] = bbox(geom);
	return [(minLng + maxLng) / 2, (minLat + maxLat) / 2];
}
